import { useEffect, useState } from 'react'

import { calculateTimeLeft, formatNumberIn2Digits } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import { StyledTime } from './LotClosingTimer.styles'
import translate from './LotClosingTimer.translate.json'

const { text } = getTranslate(translate)

export interface LotClosingTimerProps {
  endDate: Date
}

export function LotClosingTimer({ endDate }: LotClosingTimerProps) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endDate))

  useEffect(() => {
    const interval = setInterval(
      () => setTimeLeft(calculateTimeLeft(endDate)),
      1000
    )
    return () => {
      clearInterval(interval)
    }
  }, [endDate])

  return (
    <StyledTime>
      {timeLeft.days > 0
        ? text(timeLeft.days === 1 ? 'daysLeftSingular' : 'daysLeftPlural', {
            daysLeft: timeLeft.days,
          })
        : text('timeLeft', {
            timeLeft: `${formatNumberIn2Digits(timeLeft.hours)}:${formatNumberIn2Digits(timeLeft.minutes)}:${formatNumberIn2Digits(timeLeft.seconds)}`,
          })}
    </StyledTime>
  )
}
